import React from "react";
import { useParams } from "react-router-dom";
import { UserPanel } from "../components";
import { UserProvider } from "../providers";

function UserDetails(): JSX.Element {
  const params = useParams<{ id: string }>();
  if (params.id == null) {
    return <></>;
  }
  return (
    <UserProvider userId={params?.id}>
      <UserPanel />
    </UserProvider>
  );
}

export default UserDetails;
